import { computed } from 'vue';
import { useTranslation } from '@/composables/useTranslation';
import type { FieldTextsOptionsType } from '@/types/composables/FieldTextsTypes';

export const useFieldTexts = (options: FieldTextsOptionsType) => {
    const { t } = useTranslation();

    const getLabel = computed((): string => {
        if (!options.label) {
            return '';
        }
        if (options.isTranslated) {
            return t(options.label);
        }

        return options.label;
    });

    const getPlaceholder = computed((): string => {
        if (!options.placeholder) {
            return '';
        }
        if (options.isTranslated) {
            return t(options.placeholder);
        }

        return options.placeholder;
    });

    const getHint = computed((): string => {
        if (!options.hint) {
            return '';
        }
        if (options.isTranslated) {
            return t(options.hint);
        }

        return options.hint;
    });

    return { getLabel, getPlaceholder, getHint };
};
